import './App.css';
import Home from './pages/Home';
import { Routes, Route } from 'react-router-dom';
import Payment from './components/Payment';
import Order from './components/Order'

function App() {
  return (
    <div className="App">
     <Routes>
      <Route path="*" element={<Home />} />
      <Route path="/payment" element={<Payment />} />
      <Route exact path='/orders'  element={<Order/>} />
     </Routes>
    </div>
  );
}

export default App